/* eslint-disable */
import { Box, SvgIcon, Typography } from '@mui/material';
import SetupIcon from 'assets/icons/setup.svg';
import { func } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const NewChannelArea = ({ onClick }) => (
  <Box sx={{ cursor: 'pointer', display: 'flex', padding: '15px 1px', alignItems: 'center' }} onClick={onClick}>
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.background.paper,
        justifyContent: 'center',
        borderRadius: '5px',
        marginRight: '15px',
        width: 40,
        height: 40,
        background: theme.palette.primary.main,
      })}
    >
      <SvgIcon sx={{ color: theme => theme.palette.white, width: 17, height: 17 }}>
        <SetupIcon />
      </SvgIcon>
    </Box>
    <Box
      sx={theme => ({
        flexGrow: 1,
        height: 40,
        padding: '36px 0',
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.secondary.extraLight}`,
      })}
    >
      <Typography sx={{ color: 'primary.main', fontWeight: 'bold' }}>
        {I18n.t('EmployeesDrawer.Create new channel')}
      </Typography>
    </Box>
  </Box>
);

NewChannelArea.propTypes = {
  onClick: func.isRequired,
};

export default NewChannelArea;
